import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from '../../../../controls/modal/modal.component';
import { CompanyLite } from '../../../../shared/dto/company-lite';
import { Params, Router } from '@angular/router';
import { CustomerManagementService } from '../../../../data-services/customer-management.service';
import { EndClient } from '../../../../shared/dto/end-client';
import { UserService } from '../../../../shared/services/user.service';
import { NgForm } from '@angular/forms';
import { touchForm } from '../../../../shared/touch-form';
import { AnnuityWorkflowService } from '../../../../data-services/annuity-workflow.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'townip-bulk-freeze-modal',
  templateUrl: './bulk-freeze-modal.component.html',
  styleUrl: './bulk-freeze-modal.component.scss'
})
export class BulkFreezeModalComponent implements OnInit {

  @ViewChild(ModalComponent)
  public modal: ModalComponent;

  public companies: CompanyLite[];

  public endClients: EndClient[];

  public selectedCompany: number;

  public selectedEndClient: number;

  constructor(
    private router: Router,
    private companyService: CustomerManagementService,
    private userService: UserService,
    private annuityWorkflow: AnnuityWorkflowService,
  ) {
  }

  public ngOnInit(): void {

  }

  public async show(companyId?: number): Promise<void> {
    // Set Annuities to be selected by default
    this.selectedCompany = companyId;

    this.companies = await firstValueFrom(this.annuityWorkflow.getFreezableClients());
    this.modal.show();
  }

  public hide(): void {
    this.modal.hide();
  }

  public setupEndClient(): void {
    if (!this.selectedCompany) {
      return;
    }

    this.companyService
      .getEndClients(this.selectedCompany, false)
      .subscribe(endClients => this.endClients = endClients);
  }

  public confirm(form: NgForm): void {
    touchForm(form);

    if (form.invalid) {
      return;
    }

    const queryParams: Params = { companyId: this.selectedCompany, endClientId: this.selectedEndClient };

    if (this.userService.isInternal()) {
      this.router.navigate(['annuities', 'internal', 'bulk-price-freeze'], { queryParams });
      return;
    }

    if (this.userService.isCompany()) {
      this.router.navigate(['annuities', 'company', 'bulk-price-freeze'], { queryParams });
      return;
    }

    if (this.userService.isSalesOrAccountManager()) {
      this.router.navigate(['annuities', 'company', 'bulk-price-freeze'], { queryParams });
      return;
    }

    throw new Error('Bulk Price Freeze - no navigate handler for user type.');
  }

  public cleanup(): void {
    this.selectedCompany = undefined;
    this.selectedEndClient = undefined;
    this.endClients = undefined;
  }

}
